export const timeSeriesOfInvestmentAmountForTrends = {
    copy: 'Copy',
    chartTitle: 'Time series of recent global total investment amount',
    chartDescription:
        'Displaying the top 10 themes with the highest total investment amount applications.\nIf themes are filtered, the top 10 themes within the filtered results will be displayed.',
    themeName: 'Theme Name',
    xAxis: 'Year',
    yAxis: 'Total investment amount'
}
